<template>
  <div class="hyAiCenter">
    <!-- 消息中心 -->
    <van-nav-bar
      title="Ai助手"
      left-text
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    >
      <template #right>
        <span style="display: flex; align-items: center">
          <span
            @click="toCreate"
            style="display: flex; align-items: center; margin-right: 15px"
          >
            <svg-icon
              style="width: 22px; height: 22px"
              icon-class="hyAiAdd"
            ></svg-icon>
          </span>
          <span @click="toNews" style="display: flex; align-items: center">
            <svg-icon
              style="width: 18px; height: 18px"
              icon-class="hyAiNews"
            ></svg-icon>
          </span>
        </span>
      </template>
    </van-nav-bar>
    <div class="content" ref="scrollRef" @scroll="handleScroll">
      <div class="hyAiBanner" style="padding: 0 0.5rem">
        <svg-icon
          style="width: 100%; height: 3.2rem"
          icon-class="hyAiBanner"
        ></svg-icon>
      </div>
      <div class="hyAiList" v-if="showList" v-show="isShow">
        <div class="list">
          <div class="l-top">
            <span>您可以试着问我：</span>
          </div>
          <div class="l-list-box">
            <div
              class="l-list-content"
              v-for="(value, key) in defaultList"
              :key="key"
              @click="visitDefault(value, key)"
            >
              <div class="left">
                <div class="dianbox">
                  <span class="l-list-dian"></span>
                </div>
                <span class="l-list-text">{{ value.topic }}</span>
              </div>
              <span class="l-list-jiantou">
                <van-icon size="18px" color="#666666" name="arrow" />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="hyChat"
        style="margin-top: 10px; padding-bottom: 130px; overflow: auto"
      >
        <!-- <svg-icon style="width: 18px;height: 18px;" icon-class="hyAiYY"></svg-icon> -->
        <div v-show="isZsk" class="online-service-wrapper">
          <hYAiKnowledge ref="refHyAiKnowledge"></hYAiKnowledge>
        </div>
        <div
          v-show="dataSources.length > 0 && !isZsk"
          class="online-service-wrapper"
        >
          <hYAiMessage
            v-for="(item, index) of dataSources"
            :key="index"
            :id="item.id"
            :uuid="'' + uuid"
            :date-time="item.dateTime"
            :text="item.text"
            :reasoning="item.reasoning"
            :inversion="item.inversion"
            :error="item.error"
            :loading="item.loading"
            :tuiLi="item.tuiLi"
            :type="2"
            :des="item.des"
            @delChat="delChat"
          />
        </div>
      </div>
      <div class="hyChatFoter">
        <van-field
          v-if="modelName"
          @keypress="handleEnter"
          :disabled="loading"
          rows="1"
          v-model="prompt"
          :placeholder="'给' + modelName + '模型发送消息'"
          :autosize="{ maxHeight: 80 }"
          type="textarea"
        >
        </van-field>
        <div class="hyChatFoterOpt">
          <div class="left" style="padding: 10px 0; display: flex">
            <div
              style="
                margin-right: 0.2rem;
                width: 32px;
                height: 32px;
                background: #ccc;
                border-radius: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 0.3rem;
              "
              @click="selectZsk"
              title="知识库"
            >
              <svg-icon
                style="width: 22px; height: 22px"
                icon-class="aiZsk"
                v-if="!isZsk"
              ></svg-icon>
              <svg-icon
                style="width: 22px; height: 22px"
                icon-class="aiZskActive"
                v-if="isZsk"
              ></svg-icon>
            </div>
            <div
              style="
                margin-right: 0.2rem;
                width: 32px;
                height: 32px;
                background: #ccc;
                border-radius: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
              @click="selectNetwork"
              title="联网搜索"
              v-if="isZsk"
            >
              <svg-icon
                style="width: 22px; height: 22px"
                icon-class="aiNetWork"
                v-if="!networkVal"
              ></svg-icon>
              <svg-icon
                style="width: 22px; height: 22px"
                icon-class="aiNetWorkActive"
                v-if="networkVal"
              ></svg-icon>
            </div>
            <van-popover
              trigger="click"
              :actions="zskYyList"
              placement="top"
              @select="showZskYyLbChange"
              v-model="zskYySelectModel"
              v-if="isZsk"
            >
              <template #reference>
                <div
                  style="
                    margin-right: 0.2rem;
                    width: 32px;
                    height: 32px;
                    background: #ccc;
                    border-radius: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <svg-icon
                    style="width: 22px; height: 22px"
                    icon-class="aiAppIcon"
                  ></svg-icon>
                </div>
              </template>
            </van-popover>

            <van-button
              type="primary"
              size="small"
              v-if="isZsk && APP_KEY"
              @click="newWinOpen"
              >新窗口访问</van-button
            >
          </div>
          <div class="right" style="padding: 10px 0; display: flex">
            <div
              style="
                margin-right: 0.2rem;
                width: 32px;
                height: 32px;
                background: #ccc;
                border-radius: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
              @click="handPrompt"
            >
              <svg-icon
                style="width: 22px; height: 22px"
                icon-class="ptiShiCi"
              ></svg-icon>
            </div>
            <van-popover
              trigger="click"
              :actions="modelActions"
              placement="top"
              @select="onModelSelect"
              v-model="selectModel"
            >
              <template #reference>
                <div
                  style="
                    margin-right: 0.2rem;
                    width: 32px;
                    height: 32px;
                    background: #ccc;
                    border-radius: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                  v-if="!isZsk"
                >
                  <svg-icon
                    style="width: 22px; height: 22px"
                    icon-class="damoxing"
                  ></svg-icon>
                </div>
              </template>
            </van-popover>
            <div
              v-if="!loading && prompt"
              @click="handleSubmit"
              style="
                margin-right: 0.5rem;
                width: 32px;
                height: 32px;
                background: #ccc;
                border-radius: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <svg-icon
                style="width: 22px; height: 22px"
                icon-class="isAiSubmit"
              ></svg-icon>
            </div>
            <div
              v-if="!loading && !prompt"
              style="
                margin-right: 0.5rem;
                width: 32px;
                height: 32px;
                background: #ccc;
                border-radius: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <svg-icon
                style="width: 22px; height: 22px"
                icon-class="noAiSubmit"
              ></svg-icon>
            </div>
            <div
              v-if="loading"
              @click="handleStop"
              style="
                margin-right: 0.5rem;
                width: 32px;
                height: 32px;
                background: #ccc;
                border-radius: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <svg-icon
                style="width: 22px; height: 22px"
                icon-class="hyAiStop"
              ></svg-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showpopup" position="right" :style="{ height: '100%' }">
      <div class="history-section text2img-create-history">
        <div class="history-header">
          <van-search
            @input="searchEvent"
            v-model="searchVal"
            placeholder="搜索历史对话记录"
          />
        </div>
        <div class="list" style="padding-bottom: 30px">
          <div
            v-for="(item, index) in chatList"
            :key="index"
            style="width: 100%"
          >
            <div
              style="
                margin-bottom: 0;
                font-size: 15px;
                color: #333;
                font-weight: bold;
              "
            >
              {{ item.dategroup }}
            </div>
            <div
              class="item"
              v-for="(value, key) in item.items"
              :key="key"
              :class="uuid == value.uuid ? 'active' : ''"
            >
              <span
                class="history-text"
                style="font-size: 14px; color: #333"
                :title="value.title"
                @click="visitChat(value, key)"
              >
                {{ value.title }}
              </span>

              <van-popover
                v-model="value.showOpt"
                trigger="click"
                :actions="actions"
                placement="left"
                @select="onSelect(value, key, $event)"
              >
                <template #reference>
                  <van-icon color="#666666" size="18" name="apps-o" />
                </template>
              </van-popover>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-dialog
      :before-close="closeDia"
      v-model="editShow"
      :title="editTitle"
      show-cancel-button
    >
      <van-field v-model="editValue" placeholder="请输入新话题" />
    </van-dialog>
    <van-popup v-model="showPrompt" position="bottom">
      <div class="promptPopupSearch">
        <van-search
          @input="hadnleSearchModel"
          v-model="searchModelVal"
          placeholder="关键词搜索"
        />
      </div>
      <div class="promptPopupContainer">
        <van-tabs type="card" color="#1989fa" @click="onChangeTag">
          <van-tab v-for="(value, key) in taglist" :key="key" :title="value">
            <div class="modelOverFlowBox">
              <div class="modelContainer">
                <div
                  class="model-list"
                  style="background-color: rgb(248, 250, 252)"
                  v-for="(value, key) in moduleList"
                  @click="handleActiveModel(value)"
                  :key="key"
                >
                  <div class="model-base-info">
                    <div class="text-box">
                      <div class="text-1">
                        <span>{{ value.template_name }}</span>
                      </div>
                      <div class="text-5">
                        <span class="text-4">{{ value.template_tag }}</span>
                      </div>
                      <div class="text-2">
                        <span class="text-3">{{ value.template_memo }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </van-popup>
    <van-popup round  v-model="showYyListModel" position="bottom">
      <van-picker
        title="请选择应用"
        show-toolbar
        :columns="zskYyList"
        @cancel="showYyListModel = false"
        @confirm="onConfirmYyValue"
        value-key="text"
      />
    </van-popup>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import {
  saveAiChatMemo,
  getAiChatContent,
  deleteAiChatDetail,
  getValidAIModelPlazaList,
  GetFilterDropDownList,
  getValidAIPromptTemplate,
  getTxLkeAppList,
} from "@/api/wx.js";
import { ss } from "@/utils/storage/index.js";
import { chatCompletions } from "@/api/chat.js";
import hYAiMessage from "@/components/Message/index.vue";
import hYAiKnowledge from "@/components/Knowledge/index.vue";
import { useReadStream } from "./js.js";
import { updateAiChatMemo, getCommAiTopicList } from "@/api/wx.js";
import {
  getAiChatTopicList,
  deleteAiChatRecord,
  editAiChatTitle,
} from "@/api/wx.js";
import { createGguid } from '@/utils'
import { fetchEventSource } from "@microsoft/fetch-event-source";
const sseUrl = "https://wss.lke.cloud.tencent.com/v1/qbot/chat/sse";
let cache = {
  session_id: "", // 会话ID
  configInfo: null, // 配置信息
  chatsContent: [], // 会话聊天内容
  systemEvents: [], // 系统事件栈
  transferInfo: {
    transferStatus: false,
    transferAvatar: "",
  }, // 当前转人工状态
}; // 缓存
let timeoutTasks = {}; // 超时任务管理
const { handleStreamResponse } = useReadStream();
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.userInfo) || {},
      prompt: "",
      uuid: 0,
      history: [], // 历史对话列表
      active: 1002, // 当前对话id
      chat: [{ uuid: 1002, data: [] }], // 对话数据
      usingContext: false, // 开启多轮对话
      showModelTextarea: true,
      loading: false,
      controller: new AbortController(),
      dataSources: [],
      defaultList: [],
      limitStroll: false,
      isShow: false,
      showpopup: false,
      chatList: [],
      searchList: [],
      searchVal: "",
      showPopover: false,
      actions: [{ text: "重命名" }, { text: "删除" }],
      modelActions: [],
      editShow: false,
      editValue: "",
      editObj: null,
      editTitle: "",
      selectModel: false,
      selectModObj: {},
      showPrompt: false,
      template_tagonly: [],
      taglist: ["全部"],
      tag: "全部",
      moduleList: [],
      searchModelVal: "",
      searchModuleList: [],
      zskYyList: [], // 知识库应用列表
      zskYySelectModel: false,
      APP_KEY: "",
      isZsk: sessionStorage.getItem("showZskData")
        ? sessionStorage.getItem("showZskData") == 1
          ? true
          : false
        : false,
      networkVal: sessionStorage.getItem("showNetworkVal")
        ? sessionStorage.getItem("showNetworkVal") == 1
          ? true
          : false
        : false,
      zskYylbModel: sessionStorage.getItem("showZskYyLbData")
        ? sessionStorage.getItem("showZskYyLbData")
        : "",
      selectZskYyValue: {},
      chatId: 0,
      showYyListModel:false
    };
  },
  components: {
    hYAiMessage,
    hYAiKnowledge,
  },
  watch: {
    isZsk: {
      async handler(newBol) {
        if (newBol && this.$route.query.uuid) {
          const response = await getAiChatContent({
            autoid: 0,
            uuid: this.$route.query.uuid,
            username: this.userInfo.username,
          });
          const result = response.data;
          if (result && result.length > 0) {
            cache.chatsContent = [];
            let arr = [];
            result.forEach((item) => {
              let obj = {};
              obj.is_from_self = item.inversion;
              obj.record_id = item.id;
              obj.loading_message = false;
              obj.content = item.text;
              obj.is_final = false;
              obj.isMdExpand = false;
              obj.timestamp = parseInt(
                Number(new Date(item.dateTime).getTime() / 1000)
              );
              arr.push(obj);
            });
            this.assembleMsgContent(arr, "HISTORY");
            // setTimeout(() => {
            //   this.scrollToBottom();
            // }, 300);
          }
        }
        if (!newBol && this.$route.query.uuid) {
          this.dataSources = [];
          this.setChat(this.$route.query.uuid);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    modelName() {
      const aiInfoData = localStorage.getItem("selectAIINFO")
        ? JSON.parse(localStorage.getItem("selectAIINFO"))
        : null;
      if (this.selectZskYyValue && this.isZsk) {
        return this.selectZskYyValue.text;
      } else {
        if (aiInfoData) {
          return (
            this.selectModObj.modelid_shortcut || aiInfoData.modelid_shortcut
          );
        }
      }
    },
    showList() {
      return !this.dataSources.length && !this.$route.query.uuid;
    },
    conversationList() {
      const data = this.dataSources
        .filter((item) => item.text)
        .map((item) => ({
          role: item.inversion ? "user" : "assistant",
          content: item.text,
        }));
      return data;
    },
  },
  created() {
    this.uuid = this.$route.query.uuid;
  },
  methods: {
    onConfirmYyValue (val) {
      this.selectZskYyValue = val;
      this.showYyListModel = false;
      this.APP_KEY = val.AppKey;
      sessionStorage.setItem("APP_KEY",this.APP_KEY)
      sessionStorage.setItem("showZskYyLbData", val.AppBizId);
      // console.log(val,'onConfirmYyValueonConfirmYyValue')
    },
    async selectZsk() {
      if(!this.isZsk){
        const res = await getTxLkeAppList({
          retvalid: 0,
          username: this.userInfo.username,
        })
        if(!res.data || (res.data && res.data.length == 0)){
          Toast("应用不存在！")
          return;
        }
        if(!this.selectZskYyValue.text){
          this.showYyListModel = true;
          // console.log(this.zskYyList,'this.selectZskYyValue')
        }
        
      }
      this.isZsk = !this.isZsk;
      sessionStorage.setItem("showZskData", this.isZsk ? 1 : 0);
    },
    selectNetwork() {
      this.networkVal = !this.networkVal;
      sessionStorage.setItem("showNetworkVal", this.networkVal ? 1 : 0);
    },
    showZskYyLbChange(val) {
      sessionStorage.setItem("showZskYyLbData", val.AppBizId);
      this.selectZskYyValue = val;
      this.APP_KEY = val.AppKey;
    },
    newWinOpen() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      let host = window.location.origin;
      if (process.env.NODE_ENV === "production") {
        host = window.location.origin;
      } else {
        host = "https://v8dev.hyclound.cn:9090";
      }
      const url =
        host +
        "/aiChat/index.html#/chat?AppBizId=" +
        this.selectZskYyValue.AppBizId;
      if (isAndroid) {
        window.open(url);
      } else if (isiOS) {
        window.location.href = url;
      } else {
        window.open(url, "_blank");
      }
    },
    selectZskAppkey() {},
    hadnleSearchModel(val) {
      // 过滤数据
      const result = val
        ? this.searchModuleList.filter((item) => {
            if (
              item.template_name
                .toLocaleLowerCase()
                .indexOf(String(val).toLocaleLowerCase()) != -1 ||
              item.template_memo
                .toLocaleLowerCase()
                .indexOf(String(val).toLocaleLowerCase()) != -1
            ) {
              return item;
            }
          })
        : this.searchModuleList;
      this.moduleList = result.filter((e) => {
        return e.template_tag == this.tag || this.tag == "全部";
      });
    },
    onChangeTag(name, title) {
      this.tag = title;
      this.hadnleSearchModel(this.searchModelVal);
    },
    handleActiveModel(value) {
      this.showPrompt = false;
      this.prompt = value.template_memo;
      // console.log(value.template_memo,'jhefhfejheh')
    },
    // 获取模板标签方式下拉选项
    async _GetFilterDropDownList() {
      await GetFilterDropDownList({
        moduleno: 0,
        username: this.userInfo.username,
        listsql: "@模板标签",
      }).then((res) => {
        const template_tagonly = res.data.map((e) => {
          return e.dicvalue;
        });
        const arr = [...["全部"], ...template_tagonly];
        this.taglist = arr;
        this.template_tagonly = template_tagonly;
      });
    },
    async getModelList() {
      await getValidAIPromptTemplate({}).then((res) => {
        const data = res.data;
        this.moduleList = data;
        this.searchModuleList = JSON.parse(JSON.stringify(data));
      });
    },
    async handPrompt() {
      const toast = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: "请求中...",
      });
      await this._GetFilterDropDownList();
      await this.getModelList();
      Toast.clear();
      this.hadnleSearchModel(this.searchModelVal);
      this.showPrompt = true;
    },
    delChat(obj) {
      deleteAiChatDetail({
        username: this.userInfo.username,
        id: obj.id,
      }).then((res) => {
        for (let i = this.dataSources.length - 1; i >= 0; i--) {
          if (obj.id == this.dataSources[i].id) {
            this.dataSources.splice(i, 1);
          }
        }
      });
    },
    onModelSelect(obj) {
      const aiInfoData = localStorage.getItem("selectAIINFO")
        ? JSON.parse(localStorage.getItem("selectAIINFO"))
        : null;
      aiInfoData.record_company = obj.record_company;
      aiInfoData.default_modelid = obj.modelid;
      aiInfoData.modelname = obj.record_modelname;
      aiInfoData.modelid_shortcut = obj.text;
      this.selectModObj = obj;
      localStorage.setItem("selectAIINFO", JSON.stringify(aiInfoData));
    },
    async getValidAIModelPlazaList() {
      this.modelActions = [];
      this.zskYyList = [];
      await getValidAIModelPlazaList({
        mautoid: this.userInfo.default_model_mautoid,
      }).then((res) => {
        // modelid
        const data = res.data;
        if (data && data.length > 0) {
          data.forEach((item) => {
            let obj = {
              modelid: item.modelid,
              text: item.modelid_shortcut,
              record_company: item.record_company,
              record_modelname: item.record_modelname,
            };
            this.modelActions.push(obj);
          });
        }
      });
      await getTxLkeAppList({
        retvalid: 0,
        username: this.userInfo.username,
      }).then((res) => {
        if (res.iserror == 0 && res.data && res.data.length > 0) {
          const data = res.data;
          data.forEach((item) => {
            let obj = {
              AppKey: item.AppKey,
              text: item.Name,
              AppBizId: item.AppBizId,
              autoid: item.autoid,
              AppStatus: item.AppStatus,
            };
            this.zskYyList.push(obj);
          });
          
          if (this.zskYylbModel) {
            for (let i = 0; i <= this.zskYyList.length; i++) {
              if (
                this.zskYylbModel == this.zskYyList[i].AppBizId &&
                this.zskYyList[i].AppStatus == 2
              ) {
                this.selectZskYyValue = this.zskYyList[i];
                this.APP_KEY = this.zskYyList[i].AppKey;
                sessionStorage.setItem("APP_KEY",this.APP_KEY)
                break;
              }
            }
          }
        }
      });
    },
    searchEvent() {
      this.chatList = this.searchData(this.searchVal);
    },
    searchData(searchValue) {
      if (!searchValue) {
        return this.searchList; // 如果搜索值为空，返回原始数据
      }
      // 过滤数据
      const result = this.searchList
        .map((group) => {
          const filteredItems = group.items.filter(
            (item) => item.title.includes(searchValue) // 检查 title 是否包含搜索值
          );
          return {
            ...group,
            items: filteredItems,
          };
        })
        .filter((group) => group.items.length > 0); // 过滤掉没有匹配项的组
      return result.length > 0 ? result : [];
    },
    async onSelect(value, key, action) {
      this.editObj = value;
      if (action.text == "删除") {
        Dialog.confirm({
          title: "系统提示",
          message: "您确定删除话题“" + value.title + "”？",
        }).then(async () => {
          await deleteAiChatRecord({
            username: this.userInfo.username,
            autoid: value.autoid,
          });
          await this.handleChatList();
          cache = {
            session_id: "", // 会话ID
            configInfo: null, // 配置信息
            chatsContent: [], // 会话聊天内容
            systemEvents: [], // 系统事件栈
            transferInfo: {
              transferStatus: false,
              transferAvatar: "",
            }, // 当前转人工状态
          }; // 缓存
          timeoutTasks = {}; // 超时任务管理
          if (this.uuid == value.uuid) {
            this.$nextTick(() => {
              this.$router.push({ path: "/hyAichat" });
            });
          }
        });
      } else {
        this.editTitle = "您将修改话题“" + value.title + "”的显示！";
        this.editValue = "";
        this.editShow = true;
      }
    },
    // 弹窗关闭回调
    async closeDia(action, done) {
      if (action == "confirm") {
        if (this.editValue) {
          await editAiChatTitle({
            username: this.userInfo.username,
            uuid: this.editObj.uuid,
            title: this.editValue,
          });
          await this.handleChatList();
          done();
        } else {
          Toast.fail("不能为空！");
          done(false);
        }
      } else {
        done();
      }
    },
    async toNews() {
      await this.handleChatList();
      this.showpopup = true;
    },
    async handleChatList() {
      const response = await getAiChatTopicList({
        username: this.userInfo.username,
      });
      const data = response.data;
      data.forEach((element) => {
        element.showOpt = false;
      });
      if (data && data.length > 0) {
        const groupedData = data.reduce((acc, item) => {
          const key = item.dategroup;
          if (!acc[key]) {
            acc[key] = [];
          }

          acc[key].push(item);
          return acc;
        }, {});
        // 转换为数组对象
        this.chatList = Object.keys(groupedData).map((key) => ({
          dategroup: key,
          items: groupedData[key],
        }));
        this.searchList = JSON.parse(JSON.stringify(this.chatList));
      }
    },
    toCreate() {
      this.handleStop();
      cache = {
        session_id: "", // 会话ID
        configInfo: null, // 配置信息
        chatsContent: [], // 会话聊天内容
        systemEvents: [], // 系统事件栈
        transferInfo: {
          transferStatus: false,
          transferAvatar: "",
        }, // 当前转人工状态
      }; // 缓存
      timeoutTasks = {}; // 超时任务管理
      this.$nextTick(() => {
        this.$router.push({ path: "/hyAichat" });
      });
    },
    syncDelay(milliseconds) {
      const start = new Date().getTime();
      while (new Date().getTime() - start < milliseconds) {
        return !this.dataSources.length;
      }
    },
    sleep(arg) {
      return new Promise((resolve) => setTimeout(resolve, 300, arg));
    },
    onClickLeft() {
      this.handleStop();
      this.$nextTick(() => {
        this.$router.push("/home");
      });
    },
    handleEnter(event) {
      if (event.key == "Enter" && !event.shiftKey) {
        event.preventDefault();
        this.handleSubmit();
      }
    },
    async handleSubmit() {
      if (!this.uuid || this.uuid == 0) {
        this.addHistory({
          title: this.prompt,
          uuid: Date.now(),
          isEdit: false,
          visible: false,
        });
        ss.set("mobileChatSubmitPrompt", this.prompt);
        return;
      }
      await this.onConversation();
    },
    handleStop() {
      if (this.loading) {
        this.controller.abort();
        this.loading = false;
        this.showModelTextarea = true;
        if (this.isZsk) {
          this.asyncUpdateAiChatMemo(this.$route.query.uuid, {
            dateTime: new Date().toLocaleString(),
            text: cache.chatsContent[cache.chatsContent.length - 1].content,
            inversion: false,
            error: "",
            id: this.chatId,
          }).then((res) => {});
        }
      }
    },
    async addHistory(history, chatData) {
      const response = await saveAiChatMemo({
        username: this.userInfo.username,
        uuid: history.uuid,
        title: history.title,
        data: [],
      });
      this.history.unshift(history);
      this.chat.unshift({ uuid: history.uuid, data: [] });
      this.active = history.uuid;
      await this.reloadRoute(history.uuid);
    },
    async reloadRoute(uuid) {
      cache = {
        session_id: "", // 会话ID
        configInfo: null, // 配置信息
        chatsContent: [], // 会话聊天内容
        systemEvents: [], // 系统事件栈
        transferInfo: {
          transferStatus: false,
          transferAvatar: "",
        }, // 当前转人工状态
      }; // 缓存
      timeoutTasks = {}; // 超时任务管理
      await this.$router.push({ path: "/hyAichat", query: { uuid } });
    },
    async visitDefault(value) {
      this.showModelTextarea = false;
      this.prompt = value.topic;
      await this.handleSubmit();
    },
    async scrollToBottom() {
      await this.$nextTick();
      if (this.$refs.scrollRef && !this.limitStroll) {
        this.$refs.scrollRef.scrollTop = this.$refs.scrollRef.scrollHeight;
      }
    },
    handleScroll() {
      // this.limitStroll = true;
    },
    async getCommAiTopicListFun() {
      await getCommAiTopicList({
        username: this.userInfo.username,
      }).then((res) => {
        this.defaultList = res.data;
        this.isShow = true;
      });
    },
    async asyncUpdateAiChatMemo(uuid, obj) {
      let arr = [obj];
      await updateAiChatMemo({
        username: this.userInfo.username,
        uuid: uuid,
        data: arr,
      });
    },
    async setChat(uuid) {
      const chatIndex = this.chat.findIndex((item) => item.uuid == uuid);
      if (uuid) {
        if (chatIndex == -1) {
          const response = await getAiChatContent({
            autoid: 0,
            uuid,
            username: this.userInfo.username,
          });
          this.dataSources.unshift(...response.data);
        }
      }
    },
    visitChat(value) {
      if (this.uuid != value.uuid) {
        this.$router.push({ path: "/hyAichat", query: { uuid: value.uuid } });
      }
    },
    assembleMsgContent(msgList, type) {
      let newMsg = msgList;
      if (type == "ANSWER") {
        if (cache.chatsContent.length < 1) {
          cache.chatsContent.push(newMsg);
        } else {
          let currentList = cache.chatsContent;

          timeoutTasks[newMsg.request_id] &&
            clearTimeout(timeoutTasks[newMsg.request_id]);

          if (currentList.length === 2 && newMsg.can_rating) {
            currentList[0].transferRobot = true;
          }
          if (newMsg.transfer && newMsg.loading_message) {
            currentList.pop();
            currentList[currentList.length - 1].loading_message = false;
            currentList[currentList.length - 1] = {
              ...newMsg,
              ...currentList[currentList.length - 1],
              transfer: true,
              transferRobot: false,
            };
          } else {
            for (let i = currentList.length - 1; i >= 0; i--) {
              const { transfer, quit, transferRobot } = currentList[i];
              const tmp = {
                ...newMsg,
                transfer,
                quit,
                transferRobot,
              };
              // 答案消息流式输出覆盖（record_id）
              if (newMsg.record_id === currentList[i].record_id) {
                currentList[i] = tmp;
                break;
              }
              // 服务端问题消息确认数据，覆盖前端插入的临时问题消息数据（request_id匹配 & 自己发出的问题消息）
              if (
                newMsg.request_id &&
                newMsg.request_id === currentList[i].request_id &&
                newMsg.is_from_self
              ) {
                newMsg.is_loading = false; // 服务端确认收到问题消息，则去除”发送中“状态
                currentList[i] = tmp;
                // 非人工状态时, 并且用户发送的不是敏感消息。插入临时[正在思考中...]消息
                if (!newMsg.is_evil && !cache.transferInfo.transferStatus) {
                  currentList.push({
                    loading_message: true,
                    is_from_self: false,
                    content: "",
                    from_avatar: cache.configInfo.avatar,
                    timestamp: Number(currentList[i].timestamp), // 精确到秒
                  });
                }
                break;
              }
              // 插入最新答案消息
              if (
                Number(newMsg.timestamp) >= Number(currentList[i].timestamp)
              ) {
                if (currentList[i].loading_message) {
                  // 删除原来的[正在思考中...]消息
                  currentList[currentList.length - 1] = newMsg;
                } else {
                  currentList.splice(i + 1, 0, newMsg);
                }
                break;
              }
              if (
                i === 0 &&
                Number(newMsg.timestamp) < Number(currentList[i].timestamp)
              ) {
                currentList.splice(0, 0, newMsg);
              }
            }
          }
        }
      } else if (type == "HISTORY") {
        let currentList = cache.chatsContent;

        // 历史数据打上标签，无需展示”重新生成“和”停止生成“操作
        msgList = msgList.map((r) => {
          return {
            ...r,
            is_history: true,
            is_final: true,
          };
        });

        if (currentList.length === 0) {
          // 若消息队列为空（用户端，初始拉取历史记录，用做判断欢迎页展示场景）
          cache.chatsContent = [].concat(msgList);
        } else {
          // 若消息队列不为空
          let oldMsgCurrent = currentList[0];
          let newMsgHistory = msgList[msgList.length - 1];

          // 将历史数据拼装到消息队列中（按照时间戳重排数据）
          if (
            Number(newMsgHistory.timestamp) < Number(oldMsgCurrent.timestamp)
          ) {
            cache.chatsContent = [].concat(msgList).concat(cache.chatsContent);
          } else {
            msgList.reverse().forEach((msg) => {
              for (let i = 0; i < cache.chatsContent.length; i++) {
                if (msg.record_id === cache.chatsContent[i].record_id) {
                  // 重复覆盖
                  cache.chatsContent[i] = msg;
                  break;
                } else if (
                  Number(msg.timestamp) <=
                  Number(cache.chatsContent[i].timestamp)
                ) {
                  cache.chatsContent.splice(i, 0, msg);
                  break;
                } else if (
                  i === cache.chatsContent.length - 1 &&
                  Number(msg.timestamp) >
                    Number(cache.chatsContent[i].timestamp)
                ) {
                  cache.chatsContent.splice(i + 1, 0, msg);
                }
              }
            });
          }
        }
      }
      this.$refs.refHyAiKnowledge.renderMsgList(cache.chatsContent, type);
    },
    async onConversation() {
      const sAPPkey = this.APP_KEY || sessionStorage.getItem("APP_KEY")
      if (this.isZsk && !sAPPkey) {
        Toast("请选择应用！");
        return;
      }
      this.limitStroll = false;
      this.showModelTextarea = false;
      let message = this.prompt;
      if (this.loading) return;
      if (!message || message.trim() == "") return;
      this.controller = new AbortController();
      this.chatId = new Date().getTime();
      let obj = {
        dateTime: new Date().toLocaleString(),
        text: message,
        inversion: true,
        error: false,
        id: this.chatId,
      };
      this.dataSources.push(obj);
      await this.asyncUpdateAiChatMemo(this.$route.query.uuid, {
        dateTime: new Date().toLocaleString(),
        text: message,
        inversion: true,
        error: false,
        id: this.chatId,
      });
      if (!this.isZsk) {
        let obj2 = {
          dateTime: new Date().toLocaleString(),
          text: "",
          reasoning: "思考中...",
          loading: true,
          inversion: false,
          error: false,
          id: this.chatId,
        };
        this.dataSources.push(obj2);
      }
      this.scrollToBottom();
      this.loading = true;
      try {
        const requestId = createGguid();
        const params = {
          request_id: requestId,
          content: message,
          bot_app_key: sAPPkey,
          visitor_biz_id: "1",
          session_id: this.$route.query.uuid,
          visitor_labels: [],
          search_network: this.networkVal ? "enable" : "enable",
        };
        let response = null;
        let _this = this;
        if (this.isZsk) {
          await fetchEventSource(sseUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(params),
            openWhenHidden: true,
            signal: this.controller.signal, // 传入 abort signal
            onopen(response) {
              // console.log("【sse】Connection opened:", response);
            },
            onclose() {
              // 当连接关闭时触发（请求完成或出错）
              _this.asyncUpdateAiChatMemo(_this.$route.query.uuid, {
                dateTime: new Date().toLocaleString(),
                text: cache.chatsContent[cache.chatsContent.length - 1].content,
                inversion: false,
                error: "",
                id: _this.chatId,
              }).then((res) => {
                _this.prompt = "";
                _this.showModelTextarea = true;
                _this.loading = false;
              });
            },
            onmessage(rsp) {
              // console.log('【sse】Message from server:', rsp);
              const event = JSON.parse(rsp.data);
              // 处理reply
              if (event.type === "reply") {
                let data = event.payload;
                _this.assembleMsgContent(data, "ANSWER");
                _this.scrollToBottom();
              }
              if (event.type === "error") {
                let rep = event.payload || event;
                if (rep && rep.error) {
                  console.error(rep.error.message || "服务出错了！");
                } else {
                  console.error("服务出错了！");
                }
              }
            },
            onerror(error) {
              console.error("【sse】Error:", error);
            },
          });
        } else {
          const paramMsg = [];
          paramMsg.push({
            role: "system",
            content: "您是华跃计算机系统的人工智能助手：悦悦！",
          });
          paramMsg.push(...this.conversationList);
          paramMsg.push({ role: "user", content: message });
          response = await chatCompletions(this.controller.signal, paramMsg);
          this.prompt = "";
          if (response.status != 200) {
            const chatIndex = this.dataSources.findIndex(
              (item) => item.id == this.chatId && !item.inversion
            );
            if (chatIndex !== -1) {
              const upObj = this.dataSources[chatIndex];
              const text = this.dataSources[chatIndex].text;
              upObj.text =
                (text !== null && text !== undefined ? text : "") +
                ("\n\n服务器异常！异常状态码：" + response.status);
              upObj.inversion = false;
              upObj.error = true;
              upObj.loading = false;
              await this.asyncUpdateAiChatMemo(this.$route.query.uuid, {
                dateTime: upObj.dateTime,
                text: upObj.text,
                inversion: false,
                error: upObj.error,
                id: upObj.id,
              });
            }
            this.prompt = "";
            this.showModelTextarea = true;
            this.loading = false;
            return;
          }
          await handleStreamResponse(response, (jsonData) => {
            const contentText = jsonData.choices[0]?.delta?.content;
            const chatIndex = this.dataSources.findIndex(
              (item) => item.id == this.chatId && !item.inversion
            );
            if (chatIndex !== -1) {
              const upObj = this.dataSources[chatIndex];
              if (upObj.reasoning == "思考中...") {
                upObj.reasoning = "";
              }
              if (contentText) {
                const text = this.dataSources[chatIndex].text;
                upObj.text =
                  (text !== null && text !== undefined ? text : "") +
                  contentText;
                upObj.inversion = false;
                upObj.error = false;
                upObj.loading = false;
              }
              const resReasoning = jsonData.choices[0].delta.reasoning_content;
              if (resReasoning) {
                const reasoning = this.dataSources[chatIndex].reasoning;
                upObj.reasoning =
                  (reasoning !== null && reasoning !== undefined
                    ? reasoning
                    : "") + resReasoning;
                upObj.reasoningTime = new Date().toLocaleString();
                upObj.inversion = false;
                upObj.error = false;
                upObj.loading = true;
              }
              // console.log(this.dataSources,'this.dataSources')
            }
            this.scrollToBottom();
          });
          const obj = this.dataSources[this.dataSources.length - 1];
          await this.asyncUpdateAiChatMemo(this.$route.query.uuid, {
            dateTime: obj.dateTime,
            text: obj.text,
            inversion: false,
            error: obj.error,
            id: obj.id,
          });
          this.showModelTextarea = true;
          this.loading = false;
        }
      } catch (error) {
        console.error("创建模型流出错：", error);
        // console.log(error);
        this.loading = false;
        if (error instanceof DOMException && error.name == "AbortError") {
          const chatIndex = this.dataSources.findIndex(
            (item) => item.id == this.chatId && !item.inversion
          );
          if (chatIndex !== -1) {
            const upObj = this.dataSources[chatIndex];
            const text = this.dataSources[chatIndex].text;
            upObj.text =
              (text !== null && text !== undefined ? text : "") +
              "\n\n用户手动中断。";
            upObj.inversion = false;
            upObj.error = false;
            upObj.loading = false;
            await this.asyncUpdateAiChatMemo(this.$route.query.uuid, {
              dateTime: upObj.dateTime,
              text: upObj.text,
              inversion: false,
              error: upObj.error,
              id: upObj.id,
            });
          }
        }
        this.prompt = "";
        this.showModelTextarea = true;
      }
    },
  },
  async mounted() {
    // await this.setChat(this.$route.query.uuid);
    await this.getCommAiTopicListFun();

    if (!this.$route.query.uuid) {
      this.active = 1002;
    }
    const promptValue = ss.get("mobileChatSubmitPrompt");
    if (promptValue) {
      this.prompt = promptValue;
      ss.set("mobileChatSubmitPrompt", "");
      this.showModelTextarea = false;
      this.onConversation();
    }
    await this.getValidAIModelPlazaList();
  },
};
</script>

<style lang="less" scoped>
.hyAiCenter {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;

    /deep/ .van-nav-bar__left {
      padding: 0 0.1rem !important;
      .van-icon {
        color: #fff;
        font-size: 0.5rem !important;
      }
    }
    /deep/.van-nav-bar__right {
      padding: 0 0.25rem !important;
      &:active {
        opacity: 1 !important;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
  }
  .content {
    margin-top: 1.22667rem;
    overflow: auto;
    height: calc(100% - 92px);
    background: linear-gradient(180deg, #2b8df0 0%, #f5f5f5 42%, #f5f5f5 100%);
    .hyAiList {
      padding: 0 0.5rem;
      margin-top: 20px;
      opacity: 1;
      transition: all 0.3s;
      .list {
        width: 100%;
        height: auto;
        min-height: 50px;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 20px;
        padding: 20px;
      }
      .l-top {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 28px;
        color: #999999;
        line-height: 34px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .l-list-box {
      }
      .l-list-content {
        width: 100%;
        height: 72px;
        background: #f4f6fa;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 16px;
        margin-top: 0.26667rem;
        .left {
          display: flex;
          align-items: center;
          width: calc(100% - 0.5rem) !important;
        }
      }
      .dianbox {
        width: 0.6rem !important;
        min-width: 0.6rem !important;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .l-list-dian {
        width: 10px;
        height: 10px;
        background: #2b8df0;
        border-radius: 10px;
      }
      .l-list-text {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 28px;
        color: #2b8df0;
        line-height: 34px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        word-wrap: break-word;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .l-list-jiantou {
        min-width: 0.5rem;
        width: 0.5rem;
        display: flex;
        align-items: center;
      }
    }
    .hyChatFoter {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background: #fff;
      box-shadow: 0 0 0.13333rem 0 rgba(0, 0, 0, 0.1);
      border-top-left-radius: 20px;
      overflow: hidden;
      border-top-right-radius: 20px;
      /deep/.van-field__control {
        // background: #efefef;
      }
    }
  }
  .hyChatFoterOpt {
    display: flex;
    justify-content: space-between;
    .left {
      display: flex;
      font-size: 24px;
    }
  }
}
.text2img-create-history .list {
  align-content: flex-start;
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  gap: 16px;
  // overflow-x: hidden;
  // overflow-y: auto;
  padding: 0 0.32rem;
  width: 100%;
  max-width: 600px !important;
  // &::-webkit-scrollbar {
  //   width: 0px !important;
  //   height: 0px !important;
  // }
}
.text2img-create-history .list .item {
  align-items: center;
  aspect-ratio: auto;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  height: 64px;
  justify-content: space-between;
  width: 100%;
  position: relative;
}

.text2img-create-history .list .item {
  aspect-ratio: 1;
  // background-color: #e8e9eb;
  border-radius: 16px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  width: 100%;
  /deep/.van-popover__wrapper {
    height: 64px;
    width: 63px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: right;
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0), #fff 30%);
  }
}
.text2img-create-history .list .item .history-text {
  color: #5c5f66;
  font-weight: 400;
  line-height: 64px;
  text-align: left;
  word-break: break-all;
  white-space: nowrap;
  width: 100%;
  flex: 1;
  font-size: 32px;
}
.eaaaba55 {
  content: "";
  pointer-events: none;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  width: 84px;
}
._2f87737 {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0),
    #f9fbff 50%,
    #f9fbff 100%
  );
  width: 24px;
  content: "";
  pointer-events: none;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
}
.promptPopupContainer {
  padding: 0 0.32rem 0.32rem;
  /deep/.van-tabs__nav {
    margin: 0;
  }
  .modelOverFlowBox {
    overflow: auto;
    width: 100%;
    height: 900px;
  }

  .modelContainer {
    margin-top: 12px;
    width: 100%;

    gap: 12px !important;

    .model-list {
      padding: 16px;
      border-color: transparent !important;
      border-width: 1px !important;
      border-radius: 8px !important;
      overflow: hidden !important;
      justify-content: space-between !important;
      flex-direction: column !important;
      cursor: pointer !important;
      display: flex !important;
      position: relative !important;
      border-style: solid;
      margin-bottom: 20px;
    }
    .model-list:hover {
      border-color: #409eff !important;
      border-width: 1px !important;

      .show-model-opt {
        display: block !important;
      }
    }
    .model-list.activeCls {
      border-color: #7c3aed !important;
      border-width: 1px !important;
    }
    .model-base-info {
      position: relative !important;
      .text-box {
        --tw-text-opacity: 1 !important;
        justify-content: center !important;
        flex-direction: column !important;
        width: 100% !important;
        height: 100% !important;
      }

      .text-1 {
        font-size: 32px;
        width: 100% !important;
        margin-bottom: 10px;
        text-align: justify;
      }
      .text-5 {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .text-4 {
          font-weight: 500;
          font-size: 24px;
          color: #409eff;
          background: #e9f3fd;
          padding: 7px 10px;
          border-radius: 5px 5px 5px 5px;
        }
      }

      .text-2 {
        color: rgb(100, 116, 139);
        font-size: 24px !important;
        .text-3 {
          font-size: 24px;
          line-height: 32px;
          text-align: justify;
        }
      }
    }
  }
}
</style>
